import { Chart, PointElement, LineElement, Title, Colors, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import React from 'react';
import 'chartjs-adapter-moment';

Chart.register(PointElement, LineElement, Colors, Legend, Title);

const formatter = new Intl.NumberFormat('en-CA', {
  style: 'currency',
  currency: 'CAD',
});

const RevenueChart = ({ datasets = [], height = '350px', showTitle = true }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      colors: {
        enabled: true,
      },
      title: {
        display: showTitle,
        text: 'Annual Revenue Per Practitioner (excluding HST)',
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        beginAtZero: true,
        stacked: true,
        ticks: {
          callback: (value) => formatter.format(value),
        },
      },
    },
  };

  const data = {
    datasets: datasets.map((d) => {
      return {
        label: d.label,
        data: d.values,
      };
    }),
  };

  return (
    <div className="chart" style={{ height }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default RevenueChart;
